'use strict';

/* global gtag, fbq */

/**
 * Changes from base:
 * 1. Changed .find() function on createCarousel()
 * 2. Added new triggers on attributeSelect()
 * 3. Changed addToCart function to allow consentiments
 */

var base = require('base/product/base');
var ga4 = require('../analytics/ga4');
var metaCapi = require('../analytics/metaCapi');

// Constants
var ATTRIBUTES = {
    CLASSES: {
        ADD_TO_BASKET_ALERT: '.add-to-basket-alert',
        ADD_TO_CART_MESSAGES: '.add-to-cart-messages',
        ADD_TO_CART_URL: '.add-to-cart-url',
        ADD_TO_CART_BUTTON: 'button.add-to-cart',
        ADD_TO_CART_GLOBAL_BUTTON: 'button.add-to-cart-global',
        BUNDLE_FOOTER: '.bundle-footer',
        BUNDLE_ITEM: '.bundle-item',
        BUNDLE_ITEMS: '.bundle-items',
        CHOICE_OF_BONUS_PRODUCT: '.choice-of-bonus-product',
        CHOICE_OF_BONUS_PRODUCT_DIALOG: '.choose-bonus-product-dialog',
        CHOOSE_BONUS_PRODUCT_MODAL: '#chooseBonusProductModal',
        ENTER_MESSAGE: '.enter-message',
        INPUT_CONSENT: '#hasConsents',
        LABEL_QUANTITY: 'label.quantity',
        MINICART: '.minicart',
        MODAL_BODY: '.modal-body',
        MODAL_CONTENT: '.modal-content',
        MODAL_DIALOG: '.modal-dialog',
        MODAL_FOOTER: '.modal-footer',
        MODAL_HEADER: '.modal-header',
        OPTIONS_SELECT: '.options-select',
        PRODUCT_DETAIL: '.product-detail',
        PRODUCT_ID: '.product-id',
        PRODUCT_OPTION: '.product-option',
        PRODUCT_QUICKVIEW: '.product-quickview',
        PRODUCT_SET: '.product-set',
        PRODUCT_SET_DETAIL: '.product-set-detail',
        QUICKVIEW_DIALOG: '.quick-view-dialog',
        QUICKVIEW_MODAL: '#quickViewModal',
        QUANTITY_SELECT: '.quantity-select',
        SELECT_ASSISTIVE_TEXT: '.selected-assistive-text',
        SET_ITEMS: '.set-items',
        BONUS_PRODUCT_ITEM: '.bonus-product-item',
        MAIN_ATTRIBUTES: '.main-attributes',
        PRICES_PRICE: '.prices .price',
        PROMOTIONS: '.promotions',
        SELECT_BONUS_PRODUCT: '.select-bonus-product',
        UPDATE_CART_PRODUCT_GLOBAL_BUTTON: 'button.update-cart-product-global',
        PRODUCT_OPTIONS: '.product-options'
    },
    ELEMENTS: {
        OPTION_SELECTED: 'option:selected',
        URL: 'url'
    },
    ATTRIBUTES: {
        DATA_ADD_TO_CART_URL: 'data-addToCartUrl',
        DATA_ATTR: 'data-attr',
        DATA_ATTR_VALUE: 'data-attr-value',
        DATA_BONUS_CHOICE_RULE_BASED: 'data-bonusChoiceRuleBased',
        DATA_MORE_URL: 'data-moreURL',
        DATA_PLI_UUID: 'data-pliUUID',
        DATA_TOTAL_QTY: 'data-total-qty',
        DATA_UUID: 'data-UUID',
        DATA_PID: 'data-pid',
        DATA_READY_TO_ORDER: 'data-ready-to-order'
    },
    DATES: {
        DEFAULT: 'DD/MM/YYYY'
    },
    EMPTY_STRING: ''
};

/**
 * Quantity selector on change trigger to check product availability.
 */
base.availability = function () {
    $(document).on('change', ATTRIBUTES.CLASSES.QUANTITY_SELECT, function (e) {
        e.preventDefault();
        var $productContainer = $(this).closest(
            ATTRIBUTES.CLASSES.PRODUCT_DETAIL
        );
        if (!$productContainer.length) {
            $productContainer = $(this)
                .closest(ATTRIBUTES.CLASSES.MODAL_CONTENT)
                .find(ATTRIBUTES.CLASSES.PRODUCT_QUICKVIEW);
        }
        if (
            $(ATTRIBUTES.CLASSES.BUNDLE_ITEMS, $productContainer).length === 0
        ) {
            base.attributeSelect(
                $(e.currentTarget)
                    .find(ATTRIBUTES.ELEMENTS.OPTION_SELECTED)
                    .data(ATTRIBUTES.ELEMENTS.URL),
                $productContainer
            );
        }
    });
};

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if (
        $(ATTRIBUTES.CLASSES.QUICKVIEW_MODAL).hasClass('show') &&
        !$(ATTRIBUTES.CLASSES.PRODUCT_SET).length
    ) {
        pid = $($el)
            .closest(ATTRIBUTES.CLASSES.MODAL_CONTENT)
            .find(ATTRIBUTES.CLASSES.PRODUCT_QUICKVIEW)
            .data('pid');
    } else if (
        $(ATTRIBUTES.CLASSES.PRODUCT_SET_DETAIL).length ||
        $(ATTRIBUTES.CLASSES.PRODUCT_SET).length
    ) {
        pid = $($el)
            .closest(ATTRIBUTES.CLASSES.PRODUCT_DETAIL)
            .find(ATTRIBUTES.CLASSES.PRODUCT_ID)
            .text();
    } else {
        pid = $(
            ATTRIBUTES.CLASSES.PRODUCT_DETAIL +
                ':not(' +
                ATTRIBUTES.CLASSES.BUNDLE_ITEM +
                ')'
        ).data('pid');
    }

    return pid;
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find(ATTRIBUTES.CLASSES.PRODUCT_OPTION)
        .map(function () {
            var $elOption = $(this).find(ATTRIBUTES.CLASSES.OPTIONS_SELECT);
            var urlValue = $elOption.val();
            var selectedValueId = $elOption
                .find(
                    ATTRIBUTES.ELEMENTS.OPTION_SELECTED +
                        '[value="' +
                        urlValue +
                        '"]'
                )
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        })
        .toArray();

    return JSON.stringify(options);
}

/**
 * Retrieves URL to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $(ATTRIBUTES.CLASSES.ADD_TO_CART_URL).val();
}

/**
 * Retrieves the bundle product item IDs for the controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item IDs
 */
function getChildProducts() {
    var childProducts = [];
    $(ATTRIBUTES.CLASSES.BUNDLE_ITEM).each(function () {
        childProducts.push({
            pid: $(this).find(ATTRIBUTES.CLASSES.PRODUCT_ID).text(),
            quantity: parseInt(
                $(this)
                    .find(ATTRIBUTES.CLASSES.LABEL_QUANTITY)
                    .data('quantity'),
                10
            )
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $(ATTRIBUTES.CLASSES.SET_ITEMS).length) {
        quantitySelected = $($el)
            .closest(ATTRIBUTES.CLASSES.PRODUCT_DETAIL)
            .find(ATTRIBUTES.CLASSES.QUANTITY_SELECT);
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el)
            .closest(ATTRIBUTES.CLASSES.MODAL_FOOTER)
            .find(ATTRIBUTES.CLASSES.QUANTITY_SELECT);
        var quantitySelectedPDP = $($el)
            .closest(ATTRIBUTES.CLASSES.BUNDLE_FOOTER)
            .find(ATTRIBUTES.CLASSES.QUANTITY_SELECT);
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $(ATTRIBUTES.CLASSES.QUANTITY_SELECT);
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find(ATTRIBUTES.CLASSES.CHOICE_OF_BONUS_PRODUCT);
    var footer = $html.find(ATTRIBUTES.CLASSES.MODAL_FOOTER).children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $(ATTRIBUTES.CLASSES.MODAL_BODY).spinner().start();

    if ($(ATTRIBUTES.CLASSES.CHOOSE_BONUS_PRODUCT_MODAL).length !== 0) {
        $(ATTRIBUTES.CLASSES.CHOOSE_BONUS_PRODUCT_MODAL).remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog choose-bonus-product-dialog" ' +
        'data-total-qty="' +
        data.maxBonusItems +
        '"' +
        'data-UUID="' +
        data.uuid +
        '"' +
        'data-pliUUID="' +
        data.pliUUID +
        '"' +
        'data-addToCartUrl="' +
        data.addToCartUrl +
        '"' +
        'data-pageStart="0"' +
        'data-pageSize="' +
        data.pageSize +
        '"' +
        'data-moreURL="' +
        data.showProductsUrlRuleBased +
        '"' +
        'data-bonusChoiceRuleBased="' +
        data.bonusChoiceRuleBased +
        '">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <span class="">' +
        data.labels.selectprods +
        '</span>' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(
                response.enterDialogMessage
            );
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(
                response.closeButtonText
            );
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $(ATTRIBUTES.CLASSES.CHOOSE_BONUS_PRODUCT_MODAL).modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * Changes from app_storefront_base cartridge:
 *  - Change the handlePostCartAdd function, since the the custom made alert component is being used instead of the base one.
 * @param {string} response - ajax response from clicking the add to cart button
 * @override app_storefront_base
 */
function handlePostCartAdd(response) {
    // Constants
    const ALERT_TYPE = response.error ? 'error' : 'success';
    $('.minicart').trigger('count:update', response);
    // Show custom made alert
    if (
        response.newBonusDiscountLineItem &&
        Object.keys(response.newBonusDiscountLineItem).length !== 0
    ) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        $.alert(response.message, ALERT_TYPE, false);
    }
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find(
        $attr + ' .select-' + attr.id + ' option:first'
    );
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find(
            $attr + ' [data-attr-value="' + attrValue.value + '"]'
        );
        $attrValue.attr('value', attrValue.url).removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="'
            + attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents(
            ATTRIBUTES.CLASSES.CHOICE_OF_BONUS_PRODUCT_DIALOG
        ).length > 0;

    var isVariant;

    if (response.product.variationAttributes) {
        updateAttrs(
            response.product.variationAttributes,
            $productContainer,
            response.resources
        );

        isVariant = response.product.productType === 'variant';

        if (isChoiceOfBonusProducts && isVariant) {
            $productContainer
                .parent(ATTRIBUTES.CLASSES.BONUS_PRODUCT_ITEM)
                .data(ATTRIBUTES.ATTRIBUTES.DATA_PID, response.product.id);
            $productContainer
                .parent(ATTRIBUTES.CLASSES.BONUS_PRODUCT_ITEM)
                .data(
                    ATTRIBUTES.ATTRIBUTES.DATA_READY_TO_ORDER,
                    response.product.readyToOrder
                );
        }
    }

    // Update primary images
    var primaryImageUrls = response.product.images.large;
    base.createCarousel(primaryImageUrls, $productContainer);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $(
            ATTRIBUTES.CLASSES.PRICES_PRICE,
            $productContainer
        ).length
            ? $(ATTRIBUTES.CLASSES.PRICES_PRICE, $productContainer)
            : $(ATTRIBUTES.CLASSES.PRICES_PRICE);
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer
        .find(ATTRIBUTES.CLASSES.PROMOTIONS)
        .empty()
        .html(response.product.promotionsHtml);

    base.updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find(
            ATTRIBUTES.CLASSES.SELECT_BONUS_PRODUCT
        );
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product,
            $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $(
            `${ATTRIBUTES.CLASSES.ADD_TO_CART_BUTTON},
            ${ATTRIBUTES.CLASSES.ADD_TO_CART_GLOBAL_BUTTON},
            ${ATTRIBUTES.CLASSES.UPDATE_CART_PRODUCT_GLOBAL_BUTTON}`
        )
            .trigger('product:updateAddToCart', {
                product: response.product,
                $productContainer: $productContainer
            })
            .trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer
        .find(ATTRIBUTES.CLASSES.MAIN_ATTRIBUTES)
        .empty()
        .html(base.getAttributesHtml(response.product.attributes));
}

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer
        .find(ATTRIBUTES.CLASSES.PRODUCT_OPTIONS)
        .empty()
        .html(optionsHtml);
}

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities - Updated quantities
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if (
        $productContainer.parent(ATTRIBUTES.CLASSES.BONUS_PRODUCT_ITEM)
            .length <= 0
    ) {
        var optionsHtml = quantities
            .map(function (quantity) {
                var selected = quantity.selected ? ' selected ' : '';
                return (
                    '<option value="' +
                    quantity.value +
                    '"  data-url="' +
                    quantity.url +
                    '"' +
                    selected +
                    '>' +
                    quantity.value +
                    '</option>'
                );
            })
            .join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
base.attributeSelect = function (selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect', {
            url: selectedValueUrl,
            container: $productContainer
        });
        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger('product:afterAttributeSelect', {
                    data: data,
                    container: $productContainer
                });
                $('body').trigger('product:renderAddToCartValidation');

                setTimeout(function () {
                    $('body').trigger('product:renderPromotionMessage');
                }, 250);

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
};

/**
 * Updates the availability message for the given Product
 *
 * @param {Object} response - response from Ajax call
 * @param {jQuery} $productContainer - DOM element for a given product
 */
base.updateAvailability = function (response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue =
            '<li><div>' +
            response.resources.info_selectforstock +
            '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }
    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
};

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
base.getAttributesHtml = function (attributes) {
    if (!attributes) {
        return '';
    }
    var html = '';
    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html +=
                    '<div class="attribute-values">' +
                    attribute.label +
                    ': ' +
                    attribute.value +
                    '</div>';
            });
        }
    });
    return html;
};

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images, along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
base.createCarousel = function (imgs, $productContainer) {
    var carousel = $productContainer.find(ATTRIBUTES.CLASSES.CAROUSEL_SLIDE);
    $(carousel).carousel('dispose');
    var carouselId = $(carousel).attr('id');
    $(carousel)
        .empty()
        .append(
            '<ol class="carousel-indicators"></ol><div class="carousel-inner" role="listbox"></div><a class="carousel-control-prev" href="#' +
                carouselId +
                '" role="button" data-slide="prev"><span class="fa icon-prev" aria-hidden="true"></span><span class="sr-only">' +
                $(carousel).data('prev') +
                '</span></a><a class="carousel-control-next" href="#' +
                carouselId +
                '" role="button" data-slide="next"><span class="fa icon-next" aria-hidden="true"></span><span class="sr-only">' +
                $(carousel).data('next') +
                '</span></a>'
        );
    for (var i = 0; i < imgs.length; i++) {
        $(
            '<div class="carousel-item"><img src="' +
                imgs[i].url +
                '" class="d-block img-fluid" alt="' +
                imgs[i].alt +
                ' image number ' +
                parseInt(imgs[i].index, 10) +
                '" title="' +
                imgs[i].title +
                '" itemprop="image" /></div>'
        ).appendTo($(carousel).find('.carousel-inner'));
        $(
            '<li data-target="#' +
                carouselId +
                '" data-slide-to="' +
                i +
                '" class=""></li>'
        ).appendTo($(carousel).find('.carousel-indicators'));
    }
    $($(carousel).find('.carousel-item')).first().addClass('active');
    $($(carousel).find('.carousel-indicators > li')).first().addClass('active');
    if (imgs.length === 1) {
        $(
            $(carousel).find(
                '.carousel-indicators, a[class^="carousel-control-"]'
            )
        ).detach();
    }
    $(carousel).carousel();
    $($(carousel).find('.carousel-indicators')).attr('aria-hidden', true);
};

/**
 * Handles the selection of color attributes dynamically.
 * Binds a click event to color selection buttons, preventing default behavior and
 * dynamically updating product attributes via an AJAX call.
 */
base.colorAttribute = function () {
    $(document).on('click', '[data-attr="color"] button', function (e) {
        var $productContainer;

        e.preventDefault();

        if ($(this).attr('disabled')) {
            return;
        }

        $productContainer = $(this).closest(ATTRIBUTES.CLASSES.SET_ITEM);

        if (!$productContainer.length) {
            $productContainer = $(this).closest(
                ATTRIBUTES.CLASSES.PRODUCT_DETAIL
            );
        }

        base.attributeSelect($(this).attr('data-url'), $productContainer);
    });
};


/**
 * Handles the "Add to Cart" functionality for products.
 * Dynamically gathers product information, consent data, and options, then sends it via an AJAX request.
 * Triggers custom events before and after adding products to the cart and handles the response.
 */
base.addToCart = function () {
    $(document)
        .off('click', 'button.add-to-cart, button.add-to-cart-global')
        .on(
            'click',
            'button.add-to-cart, button.add-to-cart-global',
            function () {
                var addToCartUrl;
                var consentsArray = [];
                var consentElements;
                var pid;
                var pidsObj;
                var setPids;

                $('body').trigger('product:beforeAddToCart', this);

                var $productContainer = $(this).closest(
                    ATTRIBUTES.CLASSES.PRODUCT_DETAIL
                );

                // Product Id
                pid = getPidValue($(this));

                if (
                    $(ATTRIBUTES.CLASSES.SET_ITEMS).length &&
                    $(this).hasClass('add-to-cart-global')
                ) {
                    setPids = [];

                    $(ATTRIBUTES.CLASSES.PRODUCT_DETAIL).each(function () {
                        if (!$(this).hasClass('product-set-detail')) {
                            // Get the consent elements
                            consentElements = $(
                                ATTRIBUTES.CLASSES.PRODUCT_DETAIL
                            ).find(ATTRIBUTES.CLASSES.INPUT_CONSENT);

                            setPids.push({
                                pid: $(this)
                                    .find(ATTRIBUTES.CLASSES.PRODUCT_ID)
                                    .text(),
                                qty: $(this)
                                    .find(ATTRIBUTES.CLASSES.QUANTITY_SELECT)
                                    .val(),
                                options: getOptions($(this))
                            });

                            // Create an object with pid and if consent is checked
                            consentElements.each(function () {
                                var element = this;
                                consentsArray.push({
                                    pid: element.dataset.pid,
                                    hasConsent: element.checked
                                });
                            });
                        }
                    });

                    pidsObj = JSON.stringify(setPids);
                } else {
                    // Get the consent elements
                    consentElements = $productContainer.find(
                        ATTRIBUTES.CLASSES.INPUT_CONSENT
                    );

                    // Create an object with pid and if consent is checked
                    consentElements.each(function () {
                        var element = this;
                        consentsArray.push({
                            pid: pid,
                            hasConsent: element.checked
                        });
                    });
                }

                if (!$productContainer.length) {
                    $productContainer = $(this)
                        .closest(ATTRIBUTES.CLASSES.QUICKVIEW_DIALOG)
                        .find(ATTRIBUTES.CLASSES.PRODUCT_DETAIL);
                }

                addToCartUrl = getAddToCartUrl();

                var form = {
                    pid: pid,
                    pidsObj: pidsObj,
                    childProducts: getChildProducts(),
                    quantity: getQuantitySelected($(this)),
                    hasConsent: JSON.stringify(consentsArray) // Send the object on ajax call
                };

	                if (!$(ATTRIBUTES.CLASSES.BUNDLE_ITEM).length) {
	                    form.options = getOptions($productContainer);
	                }

	                if (typeof gtag !== 'undefined' && typeof gtag === 'function') {
	                    var currency = ga4.getCurrency();
	                    var items = [];

	                    // Product sets / global add-to-cart: emit one item per set item.
	                    if ($(ATTRIBUTES.CLASSES.SET_ITEMS).length && $(this).hasClass('add-to-cart-global')) {
	                        $(ATTRIBUTES.CLASSES.PRODUCT_DETAIL).each(function () {
	                            var $detail = $(this);
	                            if ($detail.hasClass('product-set-detail')) {
	                                return;
	                            }

	                            var setPid = $detail.find(ATTRIBUTES.CLASSES.PRODUCT_ID).text().trim();
	                            var setQty = parseInt($detail.find(ATTRIBUTES.CLASSES.QUANTITY_SELECT).val(), 10) || 1;
	                            var setName = $detail.find('.product-name').first().text().trim();
	                            var setPrice = ga4.getFirstPriceValue($detail);

	                            if (setPid) {
                                items.push({
                                    item_id: setPid,
                                    item_name: setName || setPid,
                                    price: setPrice,
                                    quantity: setQty,
                                    item_category: $detail.data('category') || undefined
                                });
                            }
                        });
	                    } else {
	                        // Single item add-to-cart
	                        var quantity = parseInt(form.quantity, 10) || 1;
	                        var productName = $productContainer.find('.product-name').first().text().trim();
	                        var productPrice = ga4.getFirstPriceValue($productContainer);

	                        items.push({
                            item_id: pid,
                            item_name: productName || pid,
                            price: productPrice,
                            quantity: quantity,
                            item_category: $productContainer.data('category') || undefined
                        });
                    }

                    var value = items.reduce(function (sum, item) {
	                        return sum + (ga4.parseDecimal(item.price) * (item.quantity || 1));
	                    }, 0);

	                    gtag('event', 'add_to_cart', {
	                        currency: currency,
	                        value: value,
	                        items: items
	                    });

                    var metaContentsAtc = items.map(function (i) {
                        return {
                            id: i.item_id,
                            quantity: i.quantity || 1,
                            item_price: ga4.parseDecimal(i.price)
                        };
                    });
                    var metaPayloadAtc = {
                        currency: currency,
                        value: value,
                        content_type: 'product',
                        content_ids: items.map(function (i) { return i.item_id; }),
                        contents: metaContentsAtc
                    };

                    metaCapi.track('AddToCart', metaPayloadAtc);

                    if (typeof fbq === 'function') {
                        fbq('track', 'AddToCart', metaPayloadAtc);
                    }
                }

                $(this).trigger('updateAddToCartFormData', form);
                if (addToCartUrl) {
                    $.ajax({
                        url: addToCartUrl,
                        method: 'POST',
                        data: form,
                        success: function (data) {
                            handlePostCartAdd(data);
                            $('body').trigger('product:afterAddToCart', data);
                            $.spinner().stop();
                            miniCartReportingUrl(data.reportingURL);
                        },
                        error: function () {
                            $.spinner().stop();
                        }
                    });
                }
            }
        );
};

module.exports = base;
